import React from "react";
import { Sparkles } from "lucide-react";

const TERMS = [
    "Tongue Biofilm",
    "Volatile Sulfur Compounds",
    "Salivary Flow",
    "Morning Breath",
    "Microbial Balance",
    "Halitosis Index",
    "Zinc Rinse",
    "Fresh Start",
];

const Row = ({ ariaHidden }) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
        {TERMS.map((t) => (
            <span key={t} className="flex items-center">
                <span className="font-serif italic text-sm sm:text-base text-[#576856] whitespace-nowrap px-6">{t}</span>
                <Sparkles size={12} strokeWidth={1.5} className="text-[#9AB098] shrink-0" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <div data-testid="editorial-marquee" className="relative border-y border-[#E4DFD3] bg-[#F5F2EA] py-3.5 overflow-hidden">
        <div className="marquee-track">
            <Row ariaHidden={false} />
            <Row ariaHidden={true} />
        </div>
    </div>
);
